import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../img/imagewithbasebath";
import { getStoreLogoUrl } from "../../../utils/imageUtils";

const StoreLogoRenderer = ({
  store,
  fallbackImage = "assets/img/logo.png",
  className = "",
  style = {},
  defaultStyle = {
    maxHeight: "80px",
    maxWidth: "200px",
    objectFit: "contain",
  },
}) => {
  const [logoError, setLogoError] = useState(false);

  // Reset logo error when store changes
  useEffect(() => {
    setLogoError(false);
  }, [store?.logo]);

  const logoInfo = getStoreLogoUrl(store, fallbackImage);

  return logoInfo.isUploaded && !logoError ? (
    <img
      src={logoInfo.url}
      className={className}
      alt="Store Logo"
      style={{ ...defaultStyle, ...style }}
      onError={() => setLogoError(true)}
    />
  ) : (
    <ImageWithBasePath src={logoInfo.url} className={className} alt="logo" />
  );
};

export default StoreLogoRenderer;
